module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.1573/img/spinner.png"